import { ConcreteEncodable } from "./ConcreteEncodable";

import { OrderUpdateImplEncoder } from "../../encoder/OrderUpdateImplEncoder";

import * as CubiqTS from "../../index";
import { OrderUpdate } from "../OrderUpdate";

export class OrderUpdateImpl extends ConcreteEncodable implements OrderUpdate {
  public static enType: string = "com.bcdfx.model.event.OrderUpdateImpl";

  /*FID=1*/
  public changeMask: CubiqTS.Long | null = null;
  /*FID=2*/
  public orderId: string;
  /*FID=3*/
  public clOrdId: string;
  /*FID=4*/
  public comment1: string;
  /*FID=5*/
  public comment2: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = OrderUpdateImplEncoder.Instance;
    this.setEncodableType(OrderUpdateImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "OrderUpdateImpl[" +
      "changeMask=" +
      this.changeMask +
      "orderId=" +
      this.orderId +
      "clOrdId=" +
      this.clOrdId +
      "comment1=" +
      this.comment1 +
      "comment2=" +
      this.comment2 +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
